import { cn } from "$/lib/utils/functions/misc.functions";
import { numberFormatter } from "$/lib/utils/functions/util.functions";
import type { CellContext } from "@tanstack/react-table";

const interpolateColor = (
  value: number,
  min: number,
  max: number,
  reverse: boolean,
) => {
  const percentage = (value - min) / (max - min); // Normalize between 0 and 1

  // Define start (green), mid (light orange), and end (red) colors in RGB
  const green = [132, 188, 175]; // #84BCAF
  const orange = [253, 190, 151]; // rgb(253, 190, 151) (Light Orange)
  const red = [239, 68, 68]; // #EF4444

  let color;

  if (!reverse) {
    if (percentage < 0.5) {
      // Interpolate from Green to Light Orange
      const t = percentage * 2; // Scale to [0,1]
      color = green.map((c, i) => Math.round(c + t * ((orange[i] ?? 0) - c)));
    } else {
      // Interpolate from Light Orange to Red
      const t = (percentage - 0.5) * 2; // Scale to [0,1]
      color = orange.map((c, i) => Math.round(c + t * ((red[i] ?? 0) - c)));
    }
  } else {
    if (percentage < 0.5) {
      // Interpolate from Red to Light Orange
      const t = percentage * 2; // Scale to [0,1]
      color = red.map((c, i) => Math.round(c + t * ((orange[i] ?? 0) - c)));
    } else {
      // Interpolate from Light Orange to Green
      const t = (percentage - 0.5) * 2; // Scale to [0,1]
      color = orange.map((c, i) => Math.round(c + t * ((green[i] ?? 0) - c)));
    }
  }

  return `rgb(${color[0]}, ${color[1]}, ${color[2]})`;
};

type Props<T extends object> = {
  reverse?: boolean;
  tableBounds: {
    max: {
      value: number;
    };
    min: {
      value: number;
    };
  };
} & CellContext<T, number | string>;

export const RenderTableNumberCell = <T extends object>({
  reverse = false,
  tableBounds,
  ...cell
}: Props<T>) => {
  const min = tableBounds.min.value;
  const max = tableBounds.max.value;

  const isNotANumber = !cell.getValue() && typeof cell !== "number";

  return (
    <span
      className={cn(`text-xs font-medium`, {
        // "text-warning": +cell.getValue() > 240,
        // "text-danger": +cell.getValue() > 375,
        "text-black": isNotANumber,
      })}
      style={{
        color: interpolateColor(+cell.getValue(), min, max, reverse),
      }}
    >
      {isNotANumber ? "-" : numberFormatter(cell.getValue())}
    </span>
  );
};
